import React, { FC } from 'react';
import { Button, Space } from 'antd';
import { LayersIcon } from '../../icons/LayersIcon';
import { CultureIcon } from '../../icons/CultureIcon';
import { AimOutlined, DownOutlined, GlobalOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useMapSlice } from '../../slice';
import { MapMenuType } from '../../slice/types';
import { useTranslation } from 'react-i18next';
import { selectShowCurrentUserLocation } from '../../slice/selectors';

interface IProps {
  extraHeaderButtons?: JSX.Element[];

  showCulturesMenu?: boolean;
  showLayerMenu?: boolean;
  showSelectFieldsByCulture?: boolean;

  activeMapMenu: MapMenuType;
  setActiveMapMenu: React.Dispatch<React.SetStateAction<MapMenuType>>;
}

const MapCardHeaderButtons: FC<IProps> = ({
  extraHeaderButtons,

  showCulturesMenu,
  showLayerMenu,
  showSelectFieldsByCulture,
  activeMapMenu,
  setActiveMapMenu,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { actions } = useMapSlice();

  const toggleOverlayMenu = (type: MapMenuType) => () => {
    setActiveMapMenu(type === activeMapMenu ? null : type);
  };
  const showCurrentUserLocation = useSelector(selectShowCurrentUserLocation);

  const pageHeaderExtraActions = () => {
    const extraActions: JSX.Element[] = [];
    if (extraHeaderButtons) {
      extraActions.push(...extraHeaderButtons);
    }

    if (showSelectFieldsByCulture) {
      extraActions.push(
        <Button
          type="link"
          onClick={toggleOverlayMenu('FIELD_SELECT_BY_CULTURE')}
        >
          {t('Task.CreateTask.SelectFieldsWith', 'Select fields with')}
          <DownOutlined />
        </Button>,
      );
    }

    extraActions.push(
      <Button
        key="tranport"
        type={activeMapMenu === 'TRANSPORT' ? 'primary' : 'default'}
        shape="circle"
        icon={<GlobalOutlined />}
        onClick={toggleOverlayMenu('TRANSPORT')}
      />,
    );

    if (showCulturesMenu)
      extraActions.push(
        <Button
          key="culture"
          type={activeMapMenu === 'CULTURE' ? 'primary' : 'default'}
          shape="circle"
          icon={<CultureIcon />}
          onClick={toggleOverlayMenu('CULTURE')}
        />,
      );

    if (showLayerMenu)
      extraActions.push(
        <Button
          key="layer"
          type={activeMapMenu === 'LAYER' ? 'primary' : 'default'}
          shape="circle"
          icon={<LayersIcon />}
          onClick={toggleOverlayMenu('LAYER')}
        />,
      );

    extraActions.push(
      <Button
        key="centerOnUserLocation"
        shape="circle"
        type={showCurrentUserLocation ? 'primary' : 'default'}
        icon={<AimOutlined />}
        onClick={() =>
          dispatch(actions.setShowCurrentUserLocation(!showCurrentUserLocation))
        }
      />,
    );

    return (
      <Space key="0">
        {extraActions.map((action, idx) => (
          <React.Fragment key={action.key}>{action}</React.Fragment>
        ))}
      </Space>
    );
  };

  return <>{pageHeaderExtraActions()}</>;
};

export default MapCardHeaderButtons;
